import { render, staticRenderFns } from "./GetStartedCancel.vue?vue&type=template&id=03126a56&scoped=true&"
import script from "./GetStartedCancel.vue?vue&type=script&lang=js&"
export * from "./GetStartedCancel.vue?vue&type=script&lang=js&"
import style0 from "./GetStartedCancel.vue?vue&type=style&index=0&id=03126a56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03126a56",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCol,VContainer,VRow})
